module.exports = __webpack_public_path__ + "img/mission.b6d398b1.png";